import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getStates } from '~/services/States';
import { SelectItem } from '~/types';

export function useStates(
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[], unknown> {
  return useQuery<SelectItem[], unknown>(['states'], () => getStates(), {
    staleTime: 1000 * 60 * 10, // 10 minutes
    ...options,
  });
}
